// extracted by mini-css-extract-plugin
module.exports = {"ContentTitleImage":"ContentTitleImage-module--ContentTitleImage--HOGRb","SvgWrapper":"ContentTitleImage-module--SvgWrapper--3VwPT"};